export enum ResponseTypeEnum {
    FreeformResponse = 1,
    Acknowledgement = 2,
    Rating = 9,
}